"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteMaterial = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Material that are used by the individual applications for Kette.
 */
const allowedMaterial = ['NC', 'XXL', 'ESD', 'HT', 'DT', 'EG+'];
exports.KetteMaterial = {
    [echain_shared_igus_fundamentals_1.AppName.EIQ]: allowedMaterial,
    // EKE it's not allowed to change the material for kette
    [echain_shared_igus_fundamentals_1.AppName.EKE]: [],
    [echain_shared_igus_fundamentals_1.AppName.EIC]: [],
    // ECF has no kette
    [echain_shared_igus_fundamentals_1.AppName.ECF]: [],
    [echain_shared_igus_fundamentals_1.AppName.TEST]: [],
};
//# sourceMappingURL=KetteMaterial.js.map